<template>
  <a-textarea class="mars-textarea tw:bg-s-d-s-dark-background-opacity-100 tw:p-12" v-bind="attrs">
    <template v-for="(comp, name) in slots" :key="name" v-slot:[name]>
      <component :is="comp" />
    </template>
  </a-textarea>
</template>
<script lang="ts">
import { useAttrs, useSlots, defineComponent } from 'vue'
export default defineComponent({
  name: 'mars-textarea',
  inheritAttrs: false,
  setup() {
    const attrs = useAttrs()
    const slots = useSlots()
    return {
      attrs,
      slots,
    }
  },
})
</script>
<style lang="less" scoped>
.mars-textarea {
  font-family: 'Poppins', 'Inter', sans-serif !important;
  color: var(--mars-control-text);
  border-radius: 0;
  border: 1px solid var(--sds-color-border-default-primary);

  &:hover {
    border-color: var(--sds-color-border-default-primary);
  }

  &::placeholder {
    color: var(--sds-color-text-tertiary-default);
  }
}

.mars-textarea[disabled] {
  color: var(--sds-color-text-tertiary-default);
}
</style>
